const accentGradient = {
  primary: 'linear-gradient(267.23deg, #616CE0 -3.52%, #4B8DEA 99.23%)',
  hover:
    'linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), linear-gradient(267.23deg, #616CE0 -3.52%, #4B8DEA 99.23%)',
  active:
    'linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(267.23deg, #616CE0 -3.52%, #4B8DEA 99.23%)',
};

const borderGradient = {
  primary:
    'linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)), linear-gradient(267.23deg, #EFF1FC -3.52%, #EDF3FD 99.23%)',
};

const pageGradient = {
  primary:
    'linear-gradient(267.23deg, rgba(97, 108, 224, 0.1) -3.52%, rgba(75, 141, 234, 0.1) 99.23%), linear-gradient(0deg, #FFFFFF, #FFFFFF)',
};

export const gradients = {
  pageGradient,
  borderGradient,
  accentGradient,
};
